import moment from 'moment';

import StoppedIcon from '@/assets/icons/CrossSIP.svg';
import MonthlySipStatusIcon from '@/assets/icons/MonthlySipStatus.svg';
import PauseIcon from '@/assets/icons/Pause.svg';
import ActiveIcon from '@/assets/icons/Tick.svg';
import WeeklySipStatusIcon from '@/assets/icons/WeeklySipStatus.svg';

export enum ManageSIPPaymentCycleConstants {
  Weekly = 'Weekly',
  Monthly = 'Monthly',
}

export const sipStatusEnums: any = {
  ACTIVE: 'Active',
  PAUSED: 'Paused',
  CANCELLED: 'Stopped',
  INITIATED: 'Initiated',
};

export const getSipImage = (sipStatus: string) => {
  switch (sipStatus) {
    case 'ACTIVE':
      return ActiveIcon;
    case 'PAUSED':
      return PauseIcon;
    // case "STOPPED":
    case 'CANCELLED':
      return StoppedIcon;
    default:
      return StoppedIcon;
  }
};

export const getSipStatusIcon = (sipCycleName: string) => {
  switch (sipCycleName) {
    case 'W':
      return WeeklySipStatusIcon;
    case 'M':
      return MonthlySipStatusIcon;
    default:
      return null;
  }
};

export const getSipFrequency = (sipName: string) => {
  switch (sipName) {
    case 'W':
      return 'Every';
    case 'M':
      return 'Monthly on';
    default:
      return null;
  }
};

export const getCycleName = (sipName: string) => {
  switch (sipName) {
    case 'W':
      return 'Weekly';
    case 'M':
      return 'Monthly';
    default:
      return null;
  }
};

// GETTING FORMATTED DATE IN EG : 21ST MAY 2023 FORMAT
export const getFormattedDate = (date: string) => {
  if (date === undefined || date === null) return '';
  return moment(date, 'DD-MM-YYYY').format('Do MMMM YYYY');
};

// GETTING FORMATTED DATE { WEEKLY : DAY ( EG: THURSDAY ), MONTHLY : DATE ( EG: 09th ) }
export const getDayByDate = (inputDate: string, paymentCycle: string) => {
  const WeeklyDayName: string =
    getCycleName(paymentCycle) === ManageSIPPaymentCycleConstants.Weekly
      ? moment(inputDate, 'DD-MM-YYYY').format('dddd')
      : moment(inputDate, 'DD-MM-YYYY').format('Do');

  return WeeklyDayName;
};

// TODO : below are end points for handling SIP status ( Pause, Resume, Cancel )
// should be written in ApiRoutes.json when Routing is refined
export enum SIPActionTypes {
  sipPause = 'sip-pause',
  sipResume = 'sip-resume',
  sipCancel = 'sip-cancellation',
}

export enum SipEnums {
  'Active' = 'ACTIVE',
  'Paused' = 'PAUSED',
  'Cancelled' = 'CANCELLED',
  'Completed' = 'COMPLETED',
}

export enum ManageSIPConstants {
  manageSip = 'MANAGE_SIPS',
  manageSipSummary = 'MANAGE_SIP_SUMMARY',
}
